import {
  ModuleCreate,
  ModuleList,
  ModuleMultiUpdate,
  ModuleSingleUpdate,
  ModuleDelete,
  LessonUpdate,
  LessonList,
  LessonCreate,
  LessonCreateSession,
  LessonCreateAutoEvaluation,
  LessonDelete,
} from './Request';

const mapModules = modules =>
  modules.map(module => ({
    id: module.id,
    isDraft: module.isDraft,
    name: module.name,
    order: module.order,
  }));

export const lessonCreate = async ({ name, moduleId, lessonType, file, duration, isDraft = true, privateUsers }) => {
  if (!name || !moduleId || !lessonType || !file || duration === undefined) return false;

  const response = await LessonCreate({
    name,
    moduleId,
    lessonType,
    file,
    duration,
    isDraft,
    privateUsers,
  });

  return response;
};

export const lessonCreateSession = async ({
  name,
  moduleId,
  lessonType,
  description,
  meetUrl,
  address,
  time,
  date,
  isDraft = true,
  privateUsers,
}) => {
  if (!name || !moduleId || !lessonType) return false;

  const response = await LessonCreateSession({
    name,
    moduleId,
    lessonType,
    description,
    meetUrl,
    address,
    time,
    date,
    isDraft,
    privateUsers,
  });

  return response;
};

export const lessonCreateAutoEvaluation = async ({
  name,
  moduleId,
  lessonType,
  duration,
  isRandomQuestionOrder,
  isDraft,
  questions,
}) => {
  if (!name || !moduleId || !lessonType || questions.length === 0) return false;

  const response = await LessonCreateAutoEvaluation({
    name,
    moduleId,
    lessonType,
    duration,
    isRandomQuestionOrder,
    isDraft,
    questions,
  });

  return response;
};

export const lessonUpdate = async ({
  id,
  name = null,
  isDraft = null,
  file = null,
  order = null,
  isPrivate = null,
  privateUsers = null,
}) => {
  if (!id) return false;

  return LessonUpdate({
    id,
    name,
    isDraft,
    file,
    order,
    isPrivate,
    privateUsers,
  });
};

export const lessonUpdateSession = async ({
  id,
  name = null,
  description = null,
  meetUrl = null,
  address = null,
  time = null,
  date = null,
  order = null,
  isDraft = true,
  isPrivate = null,
  privateUsers = null,
  duration = null,
  isRandomQuestionOrder = false,
  preventTabSwitching = false,
  questions = null,
}) => {
  if (!id) return false;

  return LessonUpdate({
    id,
    name,
    description,
    meetUrl,
    address,
    time,
    date,
    order,
    isDraft,
    isPrivate,
    privateUsers,
    duration,
    isRandomQuestionOrder,
    preventTabSwitching,
    questions,
  });
};

export const lessonDelete = async id => LessonDelete(id);

export const lessonList = async ({ moduleId }) => LessonList({ moduleId });

export const moduleList = async ({ courseId }) => {
  const modulesFetch = await ModuleList({ courseId });
  const modules = mapModules(modulesFetch);
  const promises = [];
  modules.forEach((module, index) =>
    promises.push(
      lessonList({ moduleId: module.id }).then(lessons => {
        modules[index].lessons = lessons;
        return null;
      })
    )
  );
  await Promise.allSettled(promises);

  return modules;
};

export const createModule = async courseId => {
  const module = await ModuleCreate(courseId);
  return module;
};

export const moduleMultiUpdate = async ({ moduleData }) => {
  const response = await ModuleMultiUpdate({ moduleData });
  return response;
};

export const moduleSingleUpdate = async ({ moduleData = [] }) => {
  const response = await ModuleSingleUpdate(moduleData);
  if (response.value === 1) {
    const lessons = await lessonList({ moduleId: moduleData.id });
    moduleData.lessons = lessons;
  }
  return moduleData;
};

export const moduleDelete = async ({ id = null }) => {
  const response = await ModuleDelete(id);
  return response;
};

export default {
  createModule,
  moduleList,
  moduleMultiUpdate,
  moduleSingleUpdate,
  moduleDelete,
  lessonCreate,
  lessonCreateSession,
  lessonCreateAutoEvaluation,
  lessonUpdate,
  lessonUpdateSession,
  lessonDelete,
  lessonList,
};
